export interface IStyledProps {
  /** @ignore */
  styles?: { [key: string]: string };
}
export { default as styled } from '@reshadow/core';
export { use, css } from '@reshadow/core';
export * from '@reshadow/core';

export * from './sstyled';
